module.exports = __webpack_public_path__ + "static/smartpay_21-pos-d4efc3aa5995bab46e4c25740fbdf7dd.png";